export const footerLocationData = [
  {
    city: 'New York',
    address: '2688 Plainfield Avenue Clay NY USA',
    imageUrl: '/new-york.webp',
  },
  {
    city: 'San Francisco',
    address: '1725 Roosevelt Street San Francisco CA USA',
    imageUrl: '/san-francisco.webp',
  },
  {
    city: 'Paris',
    address: '3319 Brownton Road Memphis Paris-France',
    imageUrl: '/paris.webp',
  },
  {
    city: 'Tokyo',
    address: 'T4949 Bridge Avenue Kaplan Tokyo Japan',
    imageUrl: '/tokyo.webp',
  },
];
